import { getInMeetingExperienceProxyApiUrl } from 'in-meeting-experience-ui-components/utils/general';
import noAuthClient from '../../utils/apiClient';
const API_BASE = `${getInMeetingExperienceProxyApiUrl()}/v1/comments`;
export const fetchComments = ({
  callObjectId,
  setSkipRefresh
}) => noAuthClient.get(`${API_BASE}?objectType=ENGAGEMENT&objectId=${callObjectId}`, {
  setSkipRefresh
});
export const createComment = ({
  objectType = 'ENGAGEMENT',
  message,
  callObjectId,
  atMentionsOwnerIds,
  ctaUrl
}) => noAuthClient.post(API_BASE, {
  data: {
    objectType,
    objectId: callObjectId,
    type: 'COMMENT',
    message,
    atMentionsOwnerIds,
    ctaUrl
  }
});
export const deleteComment = commentId => noAuthClient.delete(`${API_BASE}/${commentId}`);
export const updateComment = ({
  commentId,
  message,
  atMentionsOwnerIds,
  ctaUrl
}) => noAuthClient.patch(`${API_BASE}/${commentId}`, {
  data: {
    message,
    ctaUrl,
    atMentionsOwnerIds
  }
});